import axiosInstance from '../api';
import {
  FetchCommentsReq,
  FetchCommentsRes,
  CreateCommentReq,
  CreateCommentRes,
  UpdateCommentReq,
  UpdateCommentRes,
  DeleteCommentRes
} from './commentApi.types';

/**
 * コメント一覧取得（video_id、ページネーション対応）
 * @param video_id 動画ID（必須）
 * @param page ページ番号（デフォルト: 1）
 * @param limit 1ページあたりの件数（デフォルト: 20）
 */
export const fetchComments = async (
  video_id: number | string,
  page: number = 1, 
  limit: number = 20
): Promise<FetchCommentsRes> => {
  const response = await axiosInstance.get<FetchCommentsRes>('/comments', {
    params: { video_id, page, limit }
  });
  return response.data;
};

/**
 * コメント投稿
 */
export const createComment = async (
  data: CreateCommentReq
): Promise<CreateCommentRes> => {
  const response = await axiosInstance.post<CreateCommentRes>('/comments', data, {
    headers: { 'Content-Type': 'application/json' }
  });
  return response.data;
};

/**
 * コメント更新
 */
export const updateComment = async (
  id: number, 
  data: UpdateCommentReq
): Promise<UpdateCommentRes> => {
  const response = await axiosInstance.put<UpdateCommentRes>(`/comments/${id}`, data, {
    headers: { 'Content-Type': 'application/json' }
  });
  return response.data;
};

/**
 * コメント削除 (論理削除)
 * コメントをデータベースから物理的に削除せず、deleted_atフィールドを設定して
 * 削除済みとマークします。削除されたコメントは「削除されたコメント」として表示されます。
 */
export const deleteComment = async (id: number): Promise<DeleteCommentRes> => {
  const response = await axiosInstance.delete<DeleteCommentRes>(`/comments/${id}`);
  return response.data;
}; 